import { registerPlugin } from "@wordpress/plugins";
import Plugin from "../components/plugin/Plugin";

const addPluginSidebar = () => {
	registerPlugin("magazine-blocks", { render: Plugin });
};

export default addPluginSidebar;
